import { Space } from 'antd';
import { useAuth } from '../../utils/AuthContext';
import translations from './AccountSettings.lang.json';
import { useLanguage } from '../../utils/LanguageContext';
import { EditableValues } from '../common/CommonComponents';
import PayrollElectionForm from '../PayrollElectionForm';
import PayrollElectionView from '../PayrollElectionView';

const ManagePayrollElections = () => {
  const { lang } = useLanguage(translations);
  const { userEmployments } = useAuth();

  return (
    <Space direction="vertical">
      {(userEmployments ?? []).map((employment, i) => (
        <EditableValues
          title={employment.employerName}
          key={i}
          componentData={{ employment }}
          editButtonLabel={lang('editPayrollContributions')}
          viewComponent={PayrollElectionView}
          editComponent={PayrollElectionForm}
        />
      ))}
    </Space>
  );
};

export default ManagePayrollElections;
